import axios from 'axios';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const cookieObject = cookies.getAll();
const { sub_token } = cookieObject;

export const logout = () => {
  // List of cookies to remove
  const cookiesToRemove = [
    'access_tabs',
    'business_mode',
    'customer_id',
    'customer_name',
    'email',
    'enterprise_name',
    'is_staff',
    'logo_url',
    'name',
    'profile_type',
    'sub_token',
    'token',
    'user_id'
  ];

  // Remove each cookie
  cookiesToRemove.forEach(cookie => cookies.remove(cookie));

  // Redirect to login page or perform other actions
  window.location.href = '/login';
};

const post = config => {
  if (config) {
    const headers = { ...config.headers };
    if (!config.noToken) {
      headers.Authorization = `Token ${sub_token}`;
    }
    return axios({
      url: config.url,
      method: config.method ? config.method : 'POST',
      data: config.data,
      headers
    }).catch(error => {
      if (error.response && error.response.status === 401) {
        logout();
      }
      return error.response;
    });
  }
};

const put = config => {
  if (config) {
    return axios({
      url: config.url,
      method: 'PUT',
      data: config.data,
      headers: { ...config.headers, Authorization: `Token ${sub_token}` }
    }).catch(error => {
      if (error.response && error.response.status === 401) {
        logout();
      }
      return error.response;
    });
  }
};

const get = config => {
  if (config) {
    return axios({
      url: config.url,
      method: 'GET',
      headers: {
        Authorization: `Token ${sub_token}`
      }
    }).catch(error => {
      if (error.response && error.response.status === 401) {
        logout();
      }
      return error.response;
    });
  }
};

const del = config => {
  if (config) {
    return axios({
      url: config.url,
      method: 'DELETE',
      headers: {
        Authorization: `Token ${sub_token}`
      }
    }).catch(error => {
      if (error.response && error.response.status === 401) {
        logout();
      }
      return error.response;
    });
  }
};

const getNoAuth = config => {
  if (config) {
    const options = {
      url: config.url,
      method: 'GET'
    };
    if (config?.headers) {
      options.headers = config.headers;
    }
    return axios({
      ...options
    }).catch(error => {
      if (error.response && error.response.status === 401) {
        logout();
      }
      return error.response;
    });
  }
};

export { post, get, put, del, getNoAuth };
